export enum TextBuilderTypeEnum {
  Template = 1,
  Textarea = 2,
  Parametric = 3,
  FastSend = 4,
  TemplateAndParametric = 5
}
